import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import RadioButtonUncheckedOutlinedIcon from "@material-ui/icons/RadioButtonUncheckedOutlined";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import ActionButton from "../general/ActionButton";
import { getUserDetails, getUserInformation } from "../store/userManagement";
import {
  getInsContacts,
  getInsContactsInformation,
  getIsUpdating,
  getUpdateErrors,
  addInsContact,
  deleteInsContact,
  updateInsContactDefault,
  toggleInsContactsModal,
  getInsContactsStatus,
  updateUserActiveStatus,
  toggleInsurerCodesModal,
  getInsCodeStatus,
  getInsurerCodesSelector,
  getInsCodes,
  addInsCodes,
  addBrokerageInsurer,
  getBrokerageInformation,
  getDetails,
} from "../store/brokerage";
import { getBrokerInformation } from "../store/broker";

import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { Switch } from "@material-ui/core";
import translations from "../utils/translations";

const InsurerContacts = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDetails());
  }, []);
  return <InsurerContactsPane></InsurerContactsPane>;
};

const InsurerContactsPane = () => {
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;

  return (
    <div
      style={{
        margin: "3.5rem",
      }}
    >
      <div>
        <h5
          className="px-2"
          style={{
            fontFamily: "GibsonSemiBd",
            justifyContent: "center",
            fontSize: "1.2vw",
          }}
        >
          {translations[languagepreference].brokerageAdmin.insurerHeader}
        </h5>
        <InsurerContactItems />
      </div>
    </div>
  );
};

const InsurerContactItems = () => {
  let broker = useSelector(getBrokerInformation);
  let brokerage_code = broker.information.brokerages[0].code;
  let data = {
    brokerage_code: brokerage_code,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getInsContacts(data));
    dispatch(getUserDetails({ brokerage_code }));
  }, []);
  const onAddContactClickHandle = (value) => {
    dispatch(toggleInsContactsModal(value));
  };
  const checkIfInsurerActiveForUser = (item) => {
    if (item.isactiveforusers) {
      return item.isactiveforusers;
    } else return false;
  };

  const ShowInsurerCodeHandler = (toggleValue, insurer_code) => {
    dispatch(toggleInsurerCodesModal(toggleValue));
    let data = {
      brokerage_code: brokerage_code,
      insurer_code: insurer_code,
    };
    dispatch(getInsCodes(data));
  };

  let insContacts = useSelector(getInsContactsInformation);
  let insContactsModalState = useSelector(getInsContactsStatus);
  let isUpdating = useSelector(getIsUpdating);
  let updateErrors = useSelector(getUpdateErrors);
  const [selectedInsCode, setInsCode] = useState(null);
  const [selectedInsName, setInsName] = useState(null);

  const languagepreference = broker.information.languagepreference;
  const t = translations[languagepreference].brokerageAdmin;

  return (
    <div
      className="m-4"
      style={{ fontFamily: "GibsonRegular", fontSize: "0.8vw" }}
    >
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">{t.contact}</th>
            <th scope="col">{t.active}</th>
            <th scope="col">{t.contactEmail}</th>
            <th scope="col">{t.descriptionOrName}</th>
            <th scope="col">{t.default}</th>
            <th scope="col"></th> {/* If intentionally empty */}
            <th scope="col" className="text-center">
              {t.addInsurerCode}
            </th>
          </tr>
        </thead>

        <tbody>
          {insContacts ? (
            insContacts.map((item, index) => {
              return (
                <Fragment key={index}>
                  <tr scope="row" className="thead-light">
                    <th style={{ paddingTop: "12px" }} scope="row">
                      {item.name}
                    </th>
                    <th>
                      <Switch
                        checked={checkIfInsurerActiveForUser(item)}
                        color="primary"
                        onChange={() => {
                          let data = {
                            insurer_code: item.code
                              ? item.code
                              : item.insurer_code,
                            isactiveforusers: !item.isactiveforusers,
                            brokerage_code: brokerage_code,
                          };
                          dispatch(updateUserActiveStatus(data)).then(
                            setTimeout(() => {
                              dispatch(getInsContacts(data));
                            }, 900)
                          );
                        }}
                      />
                    </th>
                    <th />
                    <th />
                    <th />
                    <th
                      className={
                        item.allowAdd
                          ? "text-center bg-success"
                          : "text-center bg-secondary"
                      }
                      style={{
                        width: "30px",
                        paddingTop: 5,
                        borderWidth: "5px",
                        color: "white",
                      }}
                    >
                      {isUpdating ? (
                        <Spinner animation="border" size="sm" variant="light" />
                      ) : (
                        <AddIcon
                          fontSize="large"
                          onClick={() => {
                            if (item.allowAdd) {
                              setInsCode(
                                item.code ? item.code : item.insurer_code
                              );
                              setInsName(item.name);
                              onAddContactClickHandle(true);
                            }
                          }}
                        />
                      )}
                    </th>
                    <th class="text-center">
                      <EditIcon
                        onClick={() => {
                          setInsCode(item.code ? item.code : item.insurer_code);
                          setInsName(item.name);
                          ShowInsurerCodeHandler(true, item.insurer_code);
                        }}
                      />
                    </th>
                  </tr>
                  {item.emails ? (
                    item.emails.map((e, index) => {
                      return (
                        <Fragment key={index}>
                          <tr scope="row">
                            <td></td>
                            <td></td>
                            <td>{e.email}</td>
                            <td>{e.description}</td>
                            <td>
                              {e.default == "Yes" ? (
                                <CheckCircleRoundedIcon
                                  style={{ color: "SteelBlue" }}
                                />
                              ) : (
                                <RadioButtonUncheckedOutlinedIcon
                                  style={{ color: "Gray" }}
                                  onClick={() => {
                                    let data = {
                                      insurer_code: item.code
                                        ? item.code
                                        : item.insurer_code,
                                      brokerage_code: brokerage_code,
                                      email: e.email,
                                      is_default: "Yes",
                                    };
                                    dispatch(
                                      updateInsContactDefault(data)
                                    ).then(
                                      setTimeout(() => {
                                        let data = {
                                          brokerage_code: brokerage_code,
                                        };
                                        dispatch(getInsContacts(data));
                                        Array.isArray(updateErrors) &&
                                        !updateErrors.length
                                          ? toast.success(
                                              "Default Updated Successfully"
                                            )
                                          : toast(updateErrors);
                                      }, 1000)
                                    );
                                  }}
                                />
                              )}
                            </td>
                            <td
                              className={
                                item.allowDelete
                                  ? "text-center bg-danger"
                                  : "text-center bg-secondary"
                              }
                              style={{
                                width: "40px",
                                padding: 5,
                                color: "white",
                              }}
                            >
                              <DeleteOutlineOutlinedIcon
                                onClick={() => {
                                  if (item.allowDelete) {
                                    let data = {
                                      insurer_code: item.code
                                        ? item.code
                                        : item.insurer_code,
                                      email: e.email,
                                      description: e.description,
                                      is_default: e.default,
                                      brokerage_code: brokerage_code,
                                    };
                                    dispatch(deleteInsContact(data)).then(
                                      setTimeout(() => {
                                        let data = {
                                          brokerage_code: brokerage_code,
                                        };
                                        dispatch(getInsContacts(data));
                                        Array.isArray(updateErrors) &&
                                        !updateErrors.length
                                          ? toast.success(
                                              "Contact Deleted Successfully"
                                            )
                                          : toast(updateErrors);
                                      }, 1000)
                                    );
                                  }
                                }}
                              />
                            </td>
                          </tr>
                        </Fragment>
                      );
                    })
                  ) : (
                    <Fragment>
                      <tr scope="row">
                        <td></td>
                        <td>-</td>
                        <td>-</td>
                        <td>
                          <RadioButtonUncheckedOutlinedIcon
                            style={{ color: "Gray" }}
                          />
                        </td>
                      </tr>
                    </Fragment>
                  )}
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
      <Modal
        size="md"
        isOpen={insContactsModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "40vh",
            width: "50vw",
            position: "absolute",
            top: "15vh",
            left: "25vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddInsurerContacts insName={selectedInsName} code={selectedInsCode} />
      </Modal>

      <InsurerCodesModal insName={selectedInsName} code={selectedInsCode} />
    </div>
  );
};

const AddInsurerContacts = (props) => {
  const insName = props.insName;
  const code = props.code;
  const [email, setEmail] = useState(null);
  const [description, setDescription] = useState(null);
  const [isDefault, setDefault] = useState(true);

  const dispatch = useDispatch();
  const updateErrors = useSelector(getUpdateErrors);
  const broker = useSelector(getBrokerInformation);
  const brokerage_code = broker.information.brokerages[0].code;
  const languagepreference = broker.information.languagepreference;
  const brokerageAdminTranslations =
    translations[languagepreference].brokerageAdmin;
  const onAddButtonClick = () => {
    let data = {
      insurer_name: insName,
      email: email,
      description: description,
      is_default: isDefault,
      insurer_code: code,
      brokerage_code: brokerage_code,
    };
    dispatch(addInsContact(data)).then(
      setTimeout(() => {
        let data = {
          brokerage_code: brokerage_code,
        };
        dispatch(getInsContacts(data));
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success("Added Contact Successfully")
          : toast(updateErrors);
      }, 1000)
    );
    dispatch(toggleInsContactsModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleInsContactsModal(value));
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            {brokerageAdminTranslations.enterInsurerContactDetailFor} {insName}
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblEmail" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.email}
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtEmail"
                placeholder={brokerageAdminTranslations.enterEmail}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                defaultValue={props.email}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblDescription" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.description}
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtDescription"
                placeholder={brokerageAdminTranslations.enterDescription}
                onChange={(event) => {
                  setDescription(event.target.value);
                }}
                defaultValue={props.description}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblDefault" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.makeDefault}
            </label>
            <div className="col-sm-8">
              <input
                type="checkbox"
                className="form-control"
                id="txtDefault"
                onChange={(event) => {
                  setDefault(event.target.checked);
                }}
                defaultChecked={true}
              />
            </div>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              {brokerageAdminTranslations.add}
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              {brokerageAdminTranslations.cancel}
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

const InsurerCodesModal = (props) => {
  let insCodeModalState = useSelector(getInsCodeStatus);
  let brokerage_insurer = useSelector(getInsurerCodesSelector);
  let selectedInsName = props.insName;
  let selectedInsCode = props.code;
  let [modalHeight, setmodalHeight] = useState("40vh");
  useEffect(() => {
    setmodalHeight("40vh");
  }, [selectedInsCode]);
  return (
    <Modal
      size="md"
      isOpen={insCodeModalState}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: modalHeight,
          width: "50vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      {brokerage_insurer.unique_codes &&
        brokerage_insurer?.quotesby != "external" && (
          <AddInsurerCodes
            insName={selectedInsName}
            code={selectedInsCode}
            brokerage_insurer={brokerage_insurer}
          />
        )}
      {brokerage_insurer.unique_codes &&
        brokerage_insurer?.quotesby == "external" && (
          <AddWawaInsurerCodes
            insName={selectedInsName}
            code={selectedInsCode}
            brokerage_insurer={brokerage_insurer}
            setmodalHeight={setmodalHeight}
          />
        )}
    </Modal>
  );
};

const AddInsurerCodes = (props) => {
  const insName = props.insName;
  const code = props.code;
  const brokerage_insurer = props.brokerage_insurer;
  const dispatch = useDispatch();
  const updateErrors = useSelector(getUpdateErrors);
  const broker = useSelector(getBrokerInformation);
  const brokerage_code = broker.information.brokerages[0].code;
  const languagepreference = broker.information.languagepreference;
  const brokerageAdminTranslations =
    translations[languagepreference].brokerageAdmin;
  const [insurer_unique_code1, setInsUniqueCode1] = useState(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code1
      : null
  );
  const [insurer_unique_code2, setInsUniqueCode2] = useState(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code2
      : null
  );
  const [insurer_unique_code3, setInsUniqueCode3] = useState(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code3
      : null
  );

  console.log(
    brokerage_insurer.unique_codes.length > 0
      ? brokerage_insurer.unique_codes[0].code1
      : null
  );

  const onAddButtonClick = () => {
    let data = {
      insurer_name: insName,
      insurer_unique_code1: insurer_unique_code1,
      insurer_unique_code2: insurer_unique_code2,
      insurer_unique_code3: insurer_unique_code3,
      insurer_code: code,
      brokerage_code: brokerage_code,
    };
    dispatch(addInsCodes(data)).then(
      setTimeout(() => {
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success(
              brokerageAdminTranslations.uniqueCodesSavedSuccessfully
            )
          : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleInsurerCodesModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleInsurerCodesModal(value));
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            {brokerageAdminTranslations.enterYourBrokerageCodesFor} {insName}
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblBrokerCode1" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.brokerCode1}
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode1"
                placeholder={brokerageAdminTranslations.enterBrokerCode1}
                onChange={(event) => {
                  setInsUniqueCode1(event.target.value);
                }}
                defaultValue={insurer_unique_code1}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblBrokerCode2" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.brokerCode2}
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode2"
                placeholder={brokerageAdminTranslations.enterBrokerCode2}
                onChange={(event) => {
                  setInsUniqueCode2(event.target.value);
                }}
                defaultValue={insurer_unique_code2}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label for="lblBrokerCode3" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.brokerCode3}
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode3"
                placeholder={brokerageAdminTranslations.enterBrokerCode3}
                onChange={(event) => {
                  setInsUniqueCode3(event.target.value);
                }}
                defaultValue={insurer_unique_code3}
              />
            </div>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              {brokerageAdminTranslations.add}
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              {brokerageAdminTranslations.cancel}
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

const AddWawaInsurerCodes = (props) => {
  const insName = props.insName;
  const code = props.code;
  const setmodalHeight = props.setmodalHeight;
  const brokerage_insurer = props.brokerage_insurer;
  const dispatch = useDispatch();
  const updateErrors = useSelector(getUpdateErrors);
  const broker = useSelector(getBrokerInformation);
  const brokerage_code = broker.information.brokerages[0].code;
  const gotBrokerageInfo = useSelector(getBrokerageInformation);
  const languagepreference = broker.information.languagepreference;
  const brokerageAdminTranslations =
    translations[languagepreference].brokerageAdmin;
  const brokers = [];
  let initalBranchObj = {};
  let intialBrokersObj = [];
  let userList = useSelector(getUserInformation);
  let displayWawaList = "none";
  let keys = gotBrokerageInfo.address.map(
    (x) => x.addr_line1 + " " + x.city + " " + x.postal_code
  );
  initalBranchObj = Object.fromEntries(keys.map((x) => [x, null]));

  for (let val in brokerage_insurer.unique_codes[1]) {
    if (Object.keys(initalBranchObj).includes(val)) {
      initalBranchObj[val] = brokerage_insurer.unique_codes[1][val];
    }
  }

  //show user list if defined for extneral insurer
  if (brokerage_insurer.otherinfo?.userlist) {
    let userListEmails = userList.map((x) => x.user.email);
    for (let userListEmail of userListEmails) {
      let foundBrokerRecord = [userListEmail, userListEmail, ""];
      if (brokerage_insurer.unique_codes[2]) {
        foundBrokerRecord = brokerage_insurer.unique_codes[2].find(
          (arr) => arr[0] == userListEmail
        ) || [userListEmail, userListEmail, ""];
      }
      intialBrokersObj.push([...foundBrokerRecord]);
    }
    //setmodalHeight("80vh")
  }
  const [userCodes, setUserCodes] = useState(intialBrokersObj);
  const [inputfieldKeys, setinputfieldKeys] = useState(initalBranchObj);
  const [insurer_unique_code1, setInsUniqueCode1] = useState(
    brokerage_insurer.unique_codes[0]?.code1
  );

  const onAddButtonClick = () => {
    let data = {
      insurer_name: insName,
      inputfieldKeys,
      insurer_unique_code1: insurer_unique_code1,
      insurer_code: code,
      brokerage_code: brokerage_code,
    };
    if (userCodes.length > 0) {
      data["userCodes"] = userCodes;
    }

    dispatch(addInsCodes(data)).then(
      setTimeout(() => {
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success(
              brokerageAdminTranslations.uniqueCodesSavedSuccessfully
            )
          : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleInsurerCodesModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleInsurerCodesModal(value));
  };

  return (
    <PerfectScrollbar>
      <div style={{ verticalAlign: "middle" }}>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            {brokerageAdminTranslations.enterYourBrokerageCodesFor} {insName}
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            {keys.map((item, index) => {
              return (
                <Fragment key={index}>
                  <label for={item} className="col-sm-4 col-form-label">
                    {item}
                  </label>
                  <div className="col-sm-8">
                    <input
                      className="form-control"
                      id={item}
                      placeholder={`${
                        brokerageAdminTranslations.enterBrokerCodeForBranch
                      } ${index + 1}`}
                      onChange={(event) => {
                        setinputfieldKeys((prevState) => ({
                          ...prevState,
                          [item]: event.target.value,
                        }));
                      }}
                      defaultValue={inputfieldKeys[item]}
                    />
                  </div>
                </Fragment>
              );
            })}
            <label for="lblBrokerCode3" className="col-sm-4 col-form-label">
              {brokerageAdminTranslations.masterCode}
            </label>
            <div className="col-sm-8">
              <input
                className="form-control"
                id="txtBrokerCode3"
                placeholder={brokerageAdminTranslations.enterDefaultCode}
                onChange={(event) => {
                  setInsUniqueCode1(event.target.value);
                }}
                defaultValue={insurer_unique_code1}
              />
            </div>
          </div>
          <div className="UserList" style={{ display: "none" }}>
            {userCodes?.length > 0 && (
              <>
                <h4> {brokerageAdminTranslations.users}</h4>
                <p style={{ display: "flex" }}>
                  <div style={{ width: "2%", float: "left" }}>{"#"} </div>
                  <div
                    style={{ marginLeft: "1rem", width: "34%", float: "left" }}
                  >
                    {brokerageAdminTranslations.quoteyUserId}{" "}
                  </div>
                  <div style={{ minWidth: "21%" }}>{`${insName} User-Id`} </div>
                  <div style={{ minWidth: "27%" }}>
                    {`${insName} Password`}{" "}
                  </div>
                </p>
              </>
            )}
            {userCodes.map((item, index) => {
              return (
                <p>
                  <div style={{ width: "2%", float: "left" }}>{index} </div>
                  <div
                    style={{ marginLeft: "1rem", width: "34%", float: "left" }}
                  >
                    {item[0]}{" "}
                  </div>
                  <input
                    defaultValue={item[1]}
                    onBlur={(e) => {
                      let tmp_userCodes = [...userCodes];
                      tmp_userCodes[index][1] = e.target.value;
                      setUserCodes(tmp_userCodes);
                    }}
                  />
                  <input
                    style={{ marginLeft: "1rem" }}
                    defaultValue={item[2]}
                    onBlur={(e) => {
                      let tmp_userCodes = [...userCodes];
                      tmp_userCodes[index][2] = e.target.value;
                      setUserCodes(tmp_userCodes);
                    }}
                  />
                </p>
              );
            })}
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              {brokerageAdminTranslations.add}
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              {brokerageAdminTranslations.cancel}
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

export default InsurerContacts;
